import { render, staticRenderFns } from "./orderBatchInvoice.vue?vue&type=template&id=31555909"
import script from "./orderBatchInvoice.vue?vue&type=script&lang=js"
export * from "./orderBatchInvoice.vue?vue&type=script&lang=js"
import style0 from "./orderBatchInvoice.vue?vue&type=style&index=0&id=31555909&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports